export const GET_ALL_STATE = 'GET_ALL_STATE';
export const SET_ALL_STATE = 'SET_ALL_STATE';
export const GET_COUNTY_BY_STATE = 'GET_COUNTY_BY_STATE';
export const SET_COUNTY_BY_STATE = 'SET_COUNTY_BY_STATE';